import { ResponsivePie } from "@nivo/pie";

const COLORS = ["#3B82F6", "#10B981", "#F59E0B", "#EF4444"];

const RevenuePieChart = ({ data }) => {
  // Nivo expects id + value
  const formattedData = data.map((item, index) => ({
    id: item.name,
    label: item.name,
    value: item.value,
    color: COLORS[index % COLORS.length],
  }));

  return (
    <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
      <h3 className="text-lg font-semibold mb-4">
        Revenue Distribution
      </h3>

      <div className="h-80">
        <ResponsivePie
          data={formattedData}
          margin={{ top: 20, right: 80, bottom: 60, left: 80 }}
          
          innerRadius={0} // FULL CAKE (not donut)
          padAngle={1}
          cornerRadius={4}
          activeOuterRadiusOffset={8}

          colors={{ datum: "data.color" }}

          borderWidth={1}
          borderColor={{
            from: "color",
            modifiers: [["darker", 0.2]],
          }}

          enableArcLabels={true}
          arcLabel={(d) => `${d.value ? ((d.value / formattedData.reduce((a,b)=>a+b.value,0)) * 100).toFixed(0) : 0}%`}
          arcLabelsTextColor="#ffffff"

          enableArcLinkLabels={false}

          tooltip={({ datum }) => (
            <div className="bg-white px-3 py-2 rounded-lg shadow-md border text-sm">
              <strong>{datum.id}</strong>
              <div className="text-slate-600">
                ₹ {datum.value.toLocaleString()}
              </div>
            </div>
          )}

          theme={{
            legends: {
              text: {
                fill: "#475569",
                fontSize: 12,
              },
            },
          }}

          legends={[
            {
              anchor: "bottom",
              direction: "row",
              justify: false,
              translateY: 40,
              itemsSpacing: 20,
              itemWidth: 100,
              itemHeight: 18,
              itemTextColor: "#475569",
              symbolSize: 14,
              symbolShape: "circle",
            },
          ]}

          animate={true}
          motionConfig="gentle"
        />
      </div>
    </div>
  );
};

export default RevenuePieChart;